module.exports = __webpack_public_path__ + "images/icons_v2/juul-pod-3947ca6e.svg";